import { API_STATES } from "@/helpers";

const state = {
  exemptionsGetState       : API_STATES.NOT_REQUESTED,
  exemptionsGetError       : null,
  exemptionDeleteState     : API_STATES.NOT_REQUESTED,
  exemptionDeleteError     : null,
  exemptionCreateState     : API_STATES.NOT_REQUESTED,
  exemptionCreateError     : null,
  exemptionUpdateState     : API_STATES.NOT_REQUESTED,
  exemptionUpdateError     : null,
  userExemptionUpdating    : [],
  userExemptionUpdateError : null,
  userExemptionDeleting    : [],
  userExemptionDeleteError : null,
  taskExemptionUpdating    : [],
  taskExemptionUpdateError : null,
  taskExemptionDeleting    : [],
  taskExemptionDeleteError : null,
  exemptions               : [],
  userExemptions           : [],
  taskExemptions           : [],
  exemption                : {}
};

export default state;
